export const navLinks = [
  { label: 'Skills', pathname: '/', hash: '#skills' },
  { label: 'Work', pathname: '/', hash: '#experience' },
  { label: 'Education', pathname: '/', hash: '#formation' },
  { label: 'AI', pathname: '/', hash: '#ai' },
];

export const socialLinks = [
  {
    label: 'LinkedIn',
    url: 'https://www.linkedin.com/in/sebastien-friedberg/',
    icon: 'linkedin',
  },
  {
    label: 'Github',
    url: 'https://github.com/SebastienGt',
    icon: 'github',
  },
];
